{
  "COMPOSE_REDIRECT": {
    "OPENING": "Odpiranje novega pogovora z {email} …",
    "NO_EMAIL": "Naveden ni noben e-poštni naslov. Uporabite ?email=name@example.com",
    "CONTACT_ERROR": "Stika za {email} ni bilo mogoče najti."
  },
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Please select a conversation from left pane",
    "CSAT_REPLY_MESSAGE": "Ocenite pogovor",
    "404": "Sorry, we cannot find the conversation. Please try again",
    "SWITCH_VIEW_LAYOUT": "Switch the layout",
    "DASHBOARD_APP_TAB_MESSAGES": "Messages",
    "UNVERIFIED_SESSION": "The identity of this user is not verified",
    "NO_MESSAGE_1": "Uh oh! Looks like there are no messages from customers in your inbox.",
    "NO_MESSAGE_2": " to send a message to your page!",
    "NO_INBOX_1": "Hola! Looks like you haven't added any inboxes yet.",
    "NO_INBOX_2": " to get started",
    "NO_INBOX_AGENT": "Uh Oh! Looks like you are not part of any inbox. Please contact your administrator",
    "SEARCH_MESSAGES": "Search for messages in conversations",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Prevod",
    "EMPTY_STATE": {
      "CMD_BAR": "to open command menu",
      "KEYBOARD_SHORTCUTS": "to view keyboard shortcuts"
    },
    "SEARCH": {
      "TITLE": "Search messages",
      "RESULT_TITLE": "Search Results",
      "LOADING_MESSAGE": "Crunching data...",
      "PLACEHOLDER": "Type any text to search messages",
      "NO_MATCHING_RESULTS": "No results found."
    },
    "UNREAD_MESSAGES": "Unread Messages",
    "UNREAD_MESSAGE": "Unread Message",
    "CLICK_HERE": "Click here",
    "LOADING_INBOXES": "Loading inboxes",
    "LOADING_CONVERSATIONS": "Loading Conversations",
    "CANNOT_REPLY": "You cannot reply due to",
    "24_HOURS_WINDOW": "24 hour message window restriction",
    "NOT_ASSIGNED_TO_YOU": "This conversation is not assigned to you. Would you like to assign this conversation to yourself?",
    "ASSIGN_TO_ME": "Assign to me",
    "TWILIO_WHATSAPP_CAN_REPLY": "You can only reply to this conversation using a template message due to",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24 hour message window restriction",
    "REPLYING_TO": "You are replying to:",
    "REMOVE_SELECTION": "Remove Selection",
    "DOWNLOAD": "Download",
    "UNKNOWN_FILE_TYPE": "Unknown File",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Pred pošiljanjem izvedite:",
      "EXECUTE": "Izvedi",
      "RETRY": "Poskusi znova",
      "CONFIRM": "Izvedem zdaj?",
      "CONFIRM_YES": "Da, izvedi",
      "CONFIRM_NO": "Prekliči",
      "RUNNING": "V teku…",
      "DONE": "Izvedeno",
      "CLAIM_DELAYED": "bo vložena po dostavi naročila",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "Vložena NOVA reklamacija {reference}, {planned} je zaprta — uredite besedilo osnutka",
        "NEW_CLAIM": "Vložena NOVA reklamacija {reference} namesto dopolnitve {planned} — uredite besedilo osnutka",
        "OTHER_CLAIM": "Dopolnjena reklamacija {reference} namesto {planned} — uredite besedilo osnutka",
        "EXISTING_CLAIM": "Nova reklamacija ni bila vložena, dopolnjena je obstoječa {reference} — uredite besedilo osnutka",
        "OTHER": "Poteklo je drugače, kot je predvideval osnutek — uredite besedilo osnutka"
      },
      "FAILED": "Ni uspelo",
      "UNREACHABLE": "Bot ni dosegljiv",
      "REQUEST_FAILED": "Dejanja ni bilo mogoče zagnati, poskusite znova.",
      "ACTIONS": {
        "CANCEL_ORDER": "Prekličite naročilo",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Spremenite način plačila na plačilo po povzetju",
        "CREATE_CLAIM": "Vložite reklamacijo",
        "CREATE_OR_UPDATE_CLAIM": "Vložite ali posodobite reklamacijo",
        "EXTEND_ORDER_PICKUP_DATE": "Podaljšajte rok za prevzem"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "Uploading attachments...",
    "REPLIED_TO_STORY": "Replied to your story",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "This message is unsupported. You can view this message on the Facebook Messenger app.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "This message is unsupported. You can view this message on the Instagram app.",
    "SUCCESS_DELETE_MESSAGE": "Message deleted successfully",
    "FAIL_DELETE_MESSSAGE": "Couldn't delete message! Try again",
    "NO_RESPONSE": "No response",
    "RESPONSE": "Response",
    "RATING_TITLE": "Rating",
    "FEEDBACK_TITLE": "Feedback",
    "REPLY_MESSAGE_NOT_FOUND": "Message not available",
    "CARD": {
      "SHOW_LABELS": "Show labels",
      "HIDE_LABELS": "Hide labels"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Resolve",
      "REOPEN_ACTION": "Reopen",
      "OPEN_ACTION": "Open",
      "OPEN": "More",
      "CLOSE": "Close",
      "DETAILS": "details",
      "SNOOZED_UNTIL": "Snoozed until",
      "SNOOZED_UNTIL_TOMORROW": "Snoozed until tomorrow",
      "SNOOZED_UNTIL_NEXT_WEEK": "Snoozed until next week",
      "SNOOZED_UNTIL_NEXT_REPLY": "Snoozed until next reply",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      },
      "MORE": "More actions"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Mark as pending",
      "SNOOZE_UNTIL": "Snooze",
      "SNOOZE": {
        "TITLE": "Snooze until",
        "NEXT_REPLY": "Next reply",
        "TOMORROW": "Tomorrow",
        "NEXT_WEEK": "Next week"
      },
      "RESOLVE_WITHOUT_CSAT": "Resolve without CSAT"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Snooze until",
      "APPLY": "Snooze",
      "CANCEL": "Cancel"
    },
    "PRIORITY": {
      "TITLE": "Prioriteta",
      "OPTIONS": {
        "NONE": "Brez",
        "URGENT": "Nujno",
        "HIGH": "Visoka",
        "MEDIUM": "Srednja",
        "LOW": "Nizka"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "None",
        "INPUT_PLACEHOLDER": "Select priority",
        "NO_RESULTS": "No results found",
        "SUCCESSFUL": "Changed priority of conversation id {conversationId} to {priority}",
        "FAILED": "Couldn't change priority. Please try again."
      }
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Odpri v novem zavihku",
      "COPY_LINK": "Kopiraj povezavo do pogovora",
      "COPY_LINK_SUCCESS": "Povezava do pogovora je kopirana v odložišče",
      "PENDING": "Mark as pending",
      "RESOLVED": "Mark as resolved",
      "MARK_AS_UNREAD": "Mark as unread",
      "MARK_AS_READ": "Mark as read",
      "REOPEN": "Reopen conversation",
      "SNOOZE": {
        "TITLE": "Snooze",
        "NEXT_REPLY": "Until next reply",
        "TOMORROW": "Until tomorrow",
        "NEXT_WEEK": "Until next week"
      },
      "ASSIGN_AGENT": "Assign agent",
      "ASSIGN_LABEL": "Assign label",
      "AGENTS_LOADING": "Loading agents...",
      "ASSIGN_TEAM": "Assign team",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Conversation id {conversationId} assigned to \"{agentName}\"",
          "FAILED": "Couldn't assign agent. Please try again."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Couldn't assign label. Please try again."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Assigned team \"{team}\" to conversation id {conversationId}",
          "FAILED": "Couldn't assign team. Please try again."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Message signature",
      "ENABLE_SIGN_TOOLTIP": "Enable signature",
      "DISABLE_SIGN_TOOLTIP": "Disable signature",
      "MSG_INPUT": "Shift + enter for new line. Start with '/' to select a Canned Response.",
      "PRIVATE_MSG_INPUT": "Shift + enter for new line. This will be visible only to Agents",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Message signature is not configured, please configure it in profile settings.",
      "CLICK_HERE": "Click here to update",
      "WHATSAPP_TEMPLATES": "Predloge za WhatsApp",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "24-urno okno WhatsApp je poteklo. Odgovorite s predlogo.",
      "INSERT_SIGNATURE": "Insert signature into editor",
      "SIGNATURE_PREVIEW_IMAGE": "(image signature)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Zdi se, da je vaš odgovor v jeziku {draftLanguage}, vendar je ta pogovor v jeziku {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Prevedi",
      "REPLY": "Reply",
      "PRIVATE_NOTE": "Private Note",
      "SEND": "Send",
      "CREATE": "Add Note",
      "INSERT_READ_MORE": "Preberite več",
      "DISMISS_REPLY": "Dismiss reply",
      "REPLYING_TO": "Replying to:",
      "TIP_FORMAT_ICON": "Show rich text editor",
      "HEADING_LEVEL": {
        "LABEL": "Slog besedila",
        "NORMAL": "Navadno besedilo",
        "H1": "Naslov 1",
        "H2": "Naslov 2",
        "H3": "Naslov 3"
      },
      "EDITOR": {
        "BOLD": "Krepko",
        "ITALIC": "Ležeče",
        "UNDERLINE": "Podčrtano",
        "TEXT_COLOR": "Barva besedila",
        "BG_COLOR_LABEL": "Barva ozadja",
        "FONT_SIZE_LABEL": "Velikost pisave",
        "FONT_SIZE": {
          "XS": "Majhna",
          "SM": "Srednje majhna",
          "MD": "Privzeta",
          "LG": "Velika",
          "XL": "Zelo velika",
          "XXL": "Ogromna"
        },
        "CODE": "Koda",
        "LINK": "Dodaj ali odstrani povezavo",
        "CREATE_LINK": "Ustvari povezavo",
        "SAVE_LINK": "Shrani",
        "CANCEL": "Prekliči",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Razveljavi",
        "REDO": "Ponovno uveljavi",
        "BULLET_LIST": "Seznam z alinejami",
        "ORDERED_LIST": "Oštevilčen seznam",
        "BLOCKQUOTE": "Citat",
        "H1": "Naslov 1",
        "H2": "Naslov 2",
        "H3": "Naslov 3",
        "IMAGE_UPLOAD": "Naloži sliko",
        "CLEAR_FORMATTING": "Počisti oblikovanje",
        "COLOR": {
          "RED": "Rdeča",
          "YELLOW": "Rumena",
          "BLUE": "Modra",
          "ROSE_RED": "Rožnato rdeča",
          "DEEP_CYAN": "Temno cian",
          "ORANGE": "Oranžna",
          "PISTACHIO": "Pistacijeva",
          "PURPLE": "Vijolična",
          "FUCHSIA": "Fuksija",
          "SILVER": "Srebrna",
          "NAVY": "Mornarsko modra",
          "OLD_PINK": "Stara roza",
          "AQUA": "Turkizna",
          "BROWN": "Rjava",
          "OLIVE": "Olivna",
          "GOLD": "Zlata",
          "BEIGE": "Bež",
          "WINE": "Vinsko rdeča",
          "FOREST": "Gozdno zelena",
          "GREEN": "Zelena",
          "BLUE_GREY": "Modrosiva",
          "RUBY_RED": "Rubinasto rdeča",
          "CHESTNUT_BROWN": "Kostanjevo rjava",
          "ASH_GREY": "Pepelnato siva"
        },
        "BG_COLOR": {
          "RED": "Rdeča",
          "YELLOW": "Rumena",
          "BLUE": "Modra",
          "ROSE_RED": "Rožnato rdeča",
          "DEEP_CYAN": "Temno cian",
          "ORANGE": "Oranžna",
          "PISTACHIO": "Pistacijeva",
          "PURPLE": "Vijolična",
          "FUCHSIA": "Fuksija",
          "SILVER": "Srebrna",
          "NAVY": "Mornarsko modra",
          "OLD_PINK": "Stara roza",
          "AQUA": "Turkizna",
          "BROWN": "Rjava",
          "OLIVE": "Olivna",
          "GOLD": "Zlata",
          "BEIGE": "Bež",
          "WINE": "Vinsko rdeča",
          "FOREST": "Gozdno zelena",
          "GREEN": "Zelena",
          "BLUE_GREY": "Modrosiva",
          "RUBY_RED": "Rubinasto rdeča",
          "CHESTNUT_BROWN": "Kostanjevo rjava",
          "ASH_GREY": "Pepelnato siva"
        }
      },
      "TIP_EMOJI_ICON": "Show emoji selector",
      "TIP_ATTACH_ICON": "Attach files",
      "TIP_AUDIORECORDER_ICON": "Record audio",
      "TIP_AUDIORECORDER_PERMISSION": "Allow access to audio",
      "TIP_AUDIORECORDER_ERROR": "Could not open the audio",
      "DRAG_DROP": "Drag and drop here to attach",
      "START_AUDIO_RECORDING": "Start audio recording",
      "STOP_AUDIO_RECORDING": "Stop audio recording",
      "": "",
      "EMAIL_HEAD": {
        "TO": "TO",
        "ADD_BCC": "Add bcc",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "Emails separated by commas",
          "ERROR": "Please enter valid email addresses"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "Emails separated by commas",
          "ERROR": "Please enter valid email addresses"
        },
        "EDIT": "Edit",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Hide",
        "INCLUDE_ORIGINAL_MESSAGE": "Include original message",
        "EDIT_HEADERS": "Edit",
        "HIDE_HEADER_EDITS": "Hide edits",
        "SUBJECT": {
          "LABEL": "SUBJECT",
          "PLACEHOLDER": "Email subject",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Undefined variables",
        "MESSAGE": "You have {undefinedVariablesCount} undefined variables in your message: {undefinedVariables}. Would you like to send the message anyway?",
        "CONFIRM": {
          "YES": "Send",
          "CANCEL": "Cancel"
        }
      },
      "SEND_EMAIL": "Send email",
      "SEND_SMS": "Send SMS",
      "NO_SMS_INBOX": "Dodajte nabiralnik SMS za pošiljanje odgovorov SMS.",
      "SEND_CHAT": "Send chat",
      "REPLY_TO_THIS": "Reply to this",
      "TIP_EXPAND_ICON": "Enlarge editor",
      "TIP_COLLAPSE_ICON": "Shrink editor",
      "COPILOT": {
        "Q": "Ask robot for help"
      }
    },
    "VISIBLE_TO_AGENTS": "Private Note: Only visible to you and your team",
    "CHANGE_STATUS": "Conversation status changed",
    "CHANGE_STATUS_FAILED": "Conversation status change failed",
    "CHANGE_AGENT": "Conversation Assignee changed",
    "CHANGE_AGENT_FAILED": "Assignee change failed",
    "ASSIGN_LABEL_SUCCESFUL": "Label assigned successfully",
    "ASSIGN_LABEL_FAILED": "Label assignment failed",
    "CHANGE_TEAM": "Conversation team changed",
    "FILE_SIZE_LIMIT": "File exceeds the {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB attachment limit",
    "MESSAGE_ERROR": "Unable to send this message, please try again later",
    "SENT_BY": "Sent by:",
    "BOT": "Bot",
    "SEND_FAILED": "Couldn't send message! Try again",
    "TRY_AGAIN": "retry",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Select Agent",
      "REMOVE": "Remove",
      "ASSIGN": "Assign"
    },
    "CONTEXT_MENU": {
      "COPY": "Copy",
      "REPLY_TO": "Reply to this message",
      "DELETE": "Delete",
      "CREATE_A_CANNED_RESPONSE": "Add to canned responses",
      "TRANSLATE": "Translate",
      "COPY_PERMALINK": "Copy link to the message",
      "LINK_COPIED": "Message URL copied to the clipboard",
      "DELETE_CONFIRMATION": {
        "TITLE": "Are you sure you want to delete this message?",
        "MESSAGE": "You cannot undo this action",
        "DELETE": "Delete",
        "CANCEL": "Cancel"
      },
      "FORWARD": "Foward",
      "FORWARD_ERROR": "Failed to prepare forwarded message"
    },
    "SIDEBAR": {
      "CONTACT": "Contact",
      "COPILOT": "Copilot"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "{userName} je pogovor označil za rešenega",
          "CONTACT_RESOLVED": "Pogovor je razrešil {contactName}",
          "OPEN": "{userName} je znova odprl pogovor",
          "PENDING": "{userName} je pogovor označil kot čakajočega",
          "SNOOZED": "{userName} je preložil pogovor",
          "AUTO_RESOLVED": "Sistem je označil pogovor kot razrešen zaradi {duration} dni nedejavnosti",
          "SYSTEM_AUTO_OPEN": "Sistem je znova odprl pogovor zaradi novega dohodnega sporočila.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Conversation was marked resolved by {userName} (without CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Conversation was marked resolved by system due to {duration} hours of inactivity",
          "AUTO_RESOLVED_EMPTY": "Conversation was marked resolved by system due to being empty.",
          "BLOCKED_CONTACT_RESOLVED": "System resolved the conversation because the contact is blocked.",
          "KAUFLAND_TICKET_CLOSED": "Sistem je razrešil pogovor, ker je bil ticket zaprt na Kauflandu."
        },
        "PRIORITY": {
          "ADDED": "{userName} je nastavil prednost na {newPriority}",
          "UPDATED": "{userName} je spremenil prednost iz {oldPriority} v {newPriority}",
          "REMOVED": "{userName} je odstranil prednost"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} si je ta pogovor dodelil sebi",
          "ASSIGNED": "Dodeljeno {userName} s strani {assigneeName}",
          "REMOVED": "{userName} je preklical dodelitev pogovora"
        },
        "TEAM": {
          "ASSIGNED": "Dodeljeno {teamName} s strani {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Dodeljeno{assigneeName} preko {teamName} s strani {userName}",
          "REMOVED": "Dodelitev uporabniku {userName} preklicana s strani {teamName}"
        },
        "LABELS": {
          "ADDED": "{userName} dodal {labels}",
          "REMOVED": "{userName} odstranil {labels}"
        },
        "SLA": {
          "ADDED": "{userName} je dodal politiko SLA {slaName}",
          "REMOVED": "{userName} je odstranil politiko SLA {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} je utišal pogovor",
        "UNMUTED": "{userName} je vklopil sporočila pogovora",
        "CONTACT_BLOCKED": "{userName} je blokiral/a stik",
        "CONTACT_UNBLOCKED": "{userName} je odblokiral/a stik",
        "AUTO_RESOLUTION_MESSAGE": "Resolving the conversation as it has been inactive for a while. Please start a new conversation if you need further assistance.",
        "DOMAIN_BLOCKED": "{userName} blocked all contacts for a given domain",
        "DOMAIN_UNBLOCKED": "{userName} unblocked all the contacts for a given domain",
        "MOVED": "{userName} moved this conversation from inbox {sourceInboxName} to inbox {targetInboxName}",
        "MOVED_BY_ORDER": "Premaknjeno, ker naročila stika prihajajo samo iz trgovine {storeName} (zadnje naročilo {orderId}), katere robot odgovarja v tem predalu.",
        "MERGED": "{userName} merged conversation #{sourceId} into this conversation",
        "AUTOMATION_RULE_TRIGGERED": "Automation rule \"{ruleName}\" triggered",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automation rule \"{ruleName}\" disabled automatic priority",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automation rule \"{ruleName}\" disabled automatic labeling",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automation rule \"{ruleName}\" stopped further rule processing",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Sending message action was skipped for this auto-reply message",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Avtomatizacija je bila preskočena, ker je stik blokiran",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Avtomatizacija \"{ruleName}\" tega pogovora ni mogla premakniti iz nabiralnika {sourceInboxName} v nabiralnik {targetInboxName}, ker nabiralnika nista združljiva.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Avtomatizacija \"{ruleName}\" tega pogovora ni mogla premakniti iz nabiralnika {sourceInboxName} v nabiralnik {targetInboxName}, ker stik nima e-poštnega naslova.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Avtomatizacija \"{ruleName}\" ni mogla poslati sporočila: ta telefonski nabiralnik ne more pošiljati SMS, ker račun nima nabiralnika SMS. Pravilo je bilo izklopljeno, skrbniki pa so prejeli e-pošto.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Avtomatizacija \"{ruleName}\" ni mogla poslati sporočila: iz tega nabiralnika ni mogoče pošiljati prilog po SMS. Pravilo je bilo izklopljeno, skrbniki pa so prejeli e-pošto.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Makro \"{macroName}\" ni poslal sporočila: ta telefonski nabiralnik ne more pošiljati SMS, ker račun nima nabiralnika SMS.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Makro \"{macroName}\" ni poslal sporočila: iz tega nabiralnika ni mogoče pošiljati prilog po SMS.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Makro \"{macroName}\" ni poslal sporočila: ta pogovor obravnava bot. Najprej odprite pogovor.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Makro \"{macroName}\" ni poslal sporočila: ta nabiralnik je označen za izbris. Najprej premaknite pogovor v drug nabiralnik.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Avtomatizacija \"{ruleName}\" je poslala e-pošto na {contactEmail} v novem pogovoru [#{conversationId}]({conversationPath}) v nabiralniku {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Avtomatizacija \"{ruleName}\" je začela ta pogovor zaradi pogovora [#{conversationId}]({conversationPath}) v nabiralniku {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Avtomatizacija \"{ruleName}\" sporočila ni mogla poslati v novem pogovoru v nabiralniku {inboxName}, ker stik nima e-poštnega naslova.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Avtomatizacija \"{ruleName}\" je poslala SMS na {contactPhone} v novem pogovoru [#{conversationId}]({conversationPath}) v nabiralniku {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Avtomatizacija \"{ruleName}\" SMS-a ni mogla poslati v novem pogovoru v nabiralniku {inboxName}, ker stik nima telefonske številke.",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Agent",
            "CUSTOMER": "Stranka"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "odgovorjeno drugje, zvonilo {duration}",
            "NO_ANSWER": "brez odgovora, zvonilo {duration}",
            "REJECTED": "zavrnjeno, zvonilo {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Samodejno razrešeno po {count} neuspešnih povratnih klicih",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Posnetek klica je izbrisal uporabnik {name}, {date}"
        }
      }
    },
    "IMAGE_RESIZE": {
      "SMALL": "Small",
      "MEDIUM": "Medium",
      "LARGE": "Large",
      "ORIGINAL": "Original"
    },
    "SHOW_HIDDEN_MESSAGES": "Show hidden messages",
    "TRANSCRIPT": {
      "SHOW": "Show full transcript",
      "HIDE": "Hide full transcript",
      "DOWNLOAD": "Download transcript",
      "COPY": "Copy transcript"
    },
    "INVISIBLE_TO_CUSTOMER": "Nevidno za stranko",
    "SENT_VIA_EMAIL": "Stiku poslano tudi po e-pošti ({time})",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "FACEBOOK_CANNOT_REPLY": "If you need to continue this conversation, ",
    "PENDING_WITH_BOT_BANNER": "This conversation is being handled by AI bot. If you want to reply, open the conversation first.",
    "INBOX_DELETE_REQUESTED_BANNER": "Ta nabiralnik je označen za izbris, zato odgovor stranke nikoli ne bi prispel. Za odgovor premaknite pogovor v drug nabiralnik.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Ta stik ima še en odprt pogovor #{id}",
      "MULTIPLE": "Ta stik ima druge odprte pogovore ({count})",
      "OPEN": "Odpri",
      "SHOW": "Prikaži"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won't be able to send messages from this conversation anymore.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Cannot send message because the customer is not online and email continuity is not available.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "The customer is not online. They may not receive messages since email continuity is not available.",
    "OPEN_FILE": "Open",
    "DOWNLOAD_ATTACHMENTS": "Download all",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Download all attachments one by one",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Download all as ZIP",
    "ERROR_DOWNLOADING_FILE": "Error downloading file",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Prosi stranko, naj deli svojo telefonsko številko WhatsApp",
      "PENDING_ACTION": "Zahteva za podatke o stiku v teku",
      "STATES": {
        "PENDING": "Čaka se na podatke o stiku",
        "SHARED": "Telefonska številka deljena",
        "IDENTITY_CONFLICT": "Telefonsko številko je treba preveriti"
      }
    },
    "SLA": {
      "BREACHED": "breached"
    },
    "IMAGE_UPLOAD_ERROR": "Unable to upload image, please try again",
    "DRAFT": {
      "FILE_TOO_LARGE": "File '{fileName}' ({fileSize}) is too large for draft storage and will be skipped",
      "ATTACHMENT_SERIALIZATION_FAILED": "Failed to serialize attachment for draft storage",
      "STORAGE_QUOTA_EXCEEDED": "Storage quota exceeded. Draft saved without attachments",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Failed to save draft even without attachments",
      "SAVE_FAILED": "Failed to save conversation draft"
    },
    "COMMENT_TREE": {
      "TITLE": "Comment thread",
      "EMPTY": "No comments to display",
      "VIEW_TREE": "View comment thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Send conversation transcript",
    "DESC": "Send a copy of the conversation transcript to the specified email address",
    "SUBMIT": "Submit",
    "CANCEL": "Cancel",
    "SEND_EMAIL_SUCCESS": "The chat transcript was sent successfully",
    "SEND_EMAIL_ERROR": "There was an error, please try again",
    "FORM": {
      "SEND_TO_CONTACT": "Send the transcript to the customer",
      "SEND_TO_AGENT": "Send the transcript to the assigned agent",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Send the transcript to another email address",
      "EMAIL": {
        "PLACEHOLDER": "Enter an email address",
        "ERROR": "Please enter a valid email address"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Hey 👋, Welcome to {installationName}!",
    "DESCRIPTION": "Thanks for signing up. We want you to get the most out of {installationName}. Here are a few things you can do in {installationName} to make the experience delightful.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Read our latest updates",
    "ALL_CONVERSATION": {
      "TITLE": "All your conversations in one place",
      "DESCRIPTION": "View all the conversations from your customers in one single dashboard. You can filter the conversations by the incoming channel, label and status.",
      "NEW_LINK": "Click here to create an inbox"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Invite your team members",
      "DESCRIPTION": "Since you are getting ready to talk to your customer, bring in your teammates to assist you. You can invite your teammates by adding their email addresses to the agent list.",
      "NEW_LINK": "Click here to invite a team member"
    },
    "LABELS": {
      "TITLE": "Organize conversations with labels",
      "DESCRIPTION": "Labels provide an easier way to categorize your conversation. Create some labels like #support-enquiry, #billing-question etc., so that you can use them in a conversation later.",
      "NEW_LINK": "Click here to create tags"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Assigned Agent",
    "SELF_ASSIGN": "Assign to me",
    "TEAM_LABEL": "Assigned Team",
    "SELECT": {
      "PLACEHOLDER": "None"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Custom Data",
      "CONTACT_DETAILS": "Contact Details",
      "CONVERSATION_ACTIONS": "Conversation Actions",
      "CONVERSATION_LABELS": "Conversation Labels",
      "CONVERSATION_INFO": "Conversation Information",
      "CONTACT_ATTRIBUTES": "Contact Attributes",
      "PREVIOUS_CONVERSATION": "Previous Conversations",
      "MACROS": "Macros",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "ORDER_HISTORY": "Order History",
      "RETINO_TICKETS": "Retino Tickets"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Pending",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Create attribute",
    "NO_RECORDS_FOUND": "No attributes found",
    "UPDATE": {
      "SUCCESS": "Attribute updated successfully",
      "ERROR": "Unable to update attribute. Please try again later"
    },
    "ADD": {
      "TITLE": "Add",
      "SUCCESS": "Attribute added successfully",
      "ERROR": "Unable to add attribute. Please try again later"
    },
    "DELETE": {
      "SUCCESS": "Attribute deleted successfully",
      "ERROR": "Unable to delete attribute. Please try again later"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Add attributes",
      "PLACEHOLDER": "Search attributes",
      "NO_RESULT": "No attributes found"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "From",
    "TO": "To",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Subject"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Participating",
    "SIDEBAR_TITLE": "Conversation participants",
    "NO_RECORDS_FOUND": "No results found",
    "ADD_PARTICIPANTS": "Select participants",
    "REMANING_PARTICIPANTS_TEXT": "+{count} others",
    "REMANING_PARTICIPANT_TEXT": "+{count} other",
    "TOTAL_PARTICIPANTS_TEXT": "{count} people are participating.",
    "TOTAL_PARTICIPANT_TEXT": "{count} person is participating.",
    "NO_PARTICIPANTS_TEXT": "No one is participating!.",
    "WATCH_CONVERSATION": "Join conversation",
    "YOU_ARE_WATCHING": "You are participating",
    "API": {
      "ERROR_MESSAGE": "Could not update, try again!",
      "SUCCESS_MESSAGE": "Participants updated!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "View translated content",
    "DESC": "You can view the translated content in each langauge.",
    "ORIGINAL_CONTENT": "Original Content",
    "TRANSLATED_CONTENT": "Translated Content",
    "NO_TRANSLATIONS_AVAILABLE": "No translations are available for this content"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Someone is typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "No data found",
    "LOAD_ERROR": "Unable to load data. Please try again later."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Load more",
    "NO_RECORDS_FOUND": "No tickets found",
    "LOAD_ERROR": "Unable to load tickets from {hookName}. Please try again later.",
    "NOT_SEARCHABLE": "Contact email is not set.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Loading...",
    "NO_ORDERS": "No orders found",
    "NOT_AVAILABLE": "Customer data not available",
    "EXPAND": "Open customer profile",
    "MORE_ITEMS": "+ {count} items",
    "EXPEDITION_STATUS": "Expedition status",
    "OPEN_DETAIL": "open detail",
    "COPY_ORDER_ID": "Številka naročila",
    "EXTERNAL_ID": "Zunanji ID",
    "PAYMENT_TYPE": "Način plačila",
    "PAYMENT_DATE": "Datum plačila",
    "DELIVERY_PROVIDER": "Dostavljavec",
    "EXPECTED_DATE_OF_DELIVERY": "Pričakovana dostava",
    "DATE_OF_DELIVERY": "Dostavljeno",
    "EXPEDITION_DATE": "Datum odpreme",
    "INTERNAL_NOTE": "Opomba trgovine",
    "PACKAGE_NUMBER": "Pošiljka"
  },
  "READING": {
    "ONE": "{user} is reading this ticket",
    "TWO": "{user} and {secondUser} are reading this ticket",
    "MULTIPLE": "{user} and {count} others are reading this ticket"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Move Conversation",
    "DESCRIPTION": "Move this conversation to a different email inbox.",
    "SOURCE": {
      "TITLE": "Conversation",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Destination Inbox",
      "PLACEHOLDER": "Select an email inbox",
      "NO_RESULTS": "No other email inboxes available",
      "ERROR": "Please select a destination inbox"
    },
    "SUBMIT": "Move Conversation",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation moved successfully",
    "ERROR_MESSAGE": "Could not move conversation. Please try again."
  },
  "MERGE": {
    "TITLE": "Merge Conversations",
    "DESCRIPTION": "Merge this conversation with another conversation. All messages from this conversation will be moved to the target conversation, and this conversation will be deleted.",
    "SOURCE": {
      "TITLE": "Source Conversation (will be deleted)",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Target Conversation",
      "PLACEHOLDER": "Type conversation ID to search (e.g., 123)",
      "HELP": "Enter the conversation ID to merge all messages into.",
      "ERROR": "Please select a target conversation"
    },
    "WARNING": "Warning: This action cannot be undone. All messages will be moved to the target conversation and this conversation will be permanently deleted.",
    "SUBMIT": "Merge Conversations",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation merged successfully",
    "ERROR_MESSAGE": "Could not merge conversations. Please check the target conversation and try again.",
    "SEARCH": {
      "NO_RESULTS": "No conversation found with this ID",
      "ERROR_MESSAGE": "Could not search conversations. Please try again."
    },
    "CONFIRM": {
      "TITLE": "Confirm Merge",
      "DESCRIPTION": "Are you sure you want to merge this conversation? This action cannot be undone.",
      "YES": "Yes, Merge",
      "CANCEL": "Cancel"
    }
  }
}
